import SHA256 from 'crypto-js/sha256'

export async function sha256(input: string) {
  if (input.length === 0) {
    return ''
  }

  return SHA256(input).toString()
}
